export const DONE = 'done';
export const FAILED = 'failed';
export const PENDING = 'pending';
